export default __webpack_public_path__ + "static/media/roadMap-left-monkey.ebc6cd54.svg";